import React, { FunctionComponent, useState } from "react";
import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { Collapsible } from "@multiweb/reactComponents";
import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { createUpdateActivityCollapsibleState } from "../../../actions";
import { ActivityEditDialogTabsIndex } from "../../../enums";
import { LOC_PARTICIPANTS } from "../../../locKeys";
import { getActivityPanelStateContainer } from "../../../selectors";
import { IParticipant, WorkflowEditorProps } from "../../../types";
import { ActivityEditDialog } from "../../dialogs/editDialogs";
import { ManageButton, PropertyRow } from "../components";

type ParticipantsContainerProps = {
    readonly isOpen: boolean;
    readonly picassoIndex: number;
    readonly participants: readonly IParticipant[];
    readonly onActivityCollapsibleChanged: (isExpanded: boolean) => void;
    readonly participantsText: string;
} & WorkflowEditorProps;

const ParticipantsContainerComponent: FunctionComponent<ParticipantsContainerProps> = ({ hostKey, picassoIndex, participants, isOpen, onActivityCollapsibleChanged, participantsText }) => {
    const [isShown, setIsShown] = useState(false);

    const onManageButtonClick = () => {
        setIsShown(true);
    };

    const onCloseEdit = () => {
        setIsShown(false);
    };

    return (
        <Collapsible qa="participants-collapsible-section" captionText={participantsText} defaultOpened={isOpen} onExpansionChange={onActivityCollapsibleChanged} handleExpansionExternally>
            {participants.map(({ locKey, name }, index) => <PropertyRow key={`act-pr-${index}`} descriptionLocKey={locKey} value={name} />)}
            <ManageButton onClick={onManageButtonClick} {...{ hostKey }} />
            {isShown && <ActivityEditDialog defaultTabIndex={ActivityEditDialogTabsIndex.Participants} {...{ onCloseEdit, hostKey, picassoIndex }} />}
        </Collapsible>
    );
};

type StateProps = Pick<ParticipantsContainerProps, "isOpen" | "participantsText">;

const mapStateToProps: MapStateToProps<StateProps, WorkflowEditorProps, IAppState> = (state, { hostKey }) => ({
    isOpen: getActivityPanelStateContainer(state, hostKey, "PARTICIPANTS").isOpen,
    participantsText: getPrimaryText(state, LOC_PARTICIPANTS) ?? "Hráči",
});

type DispatchProps = Pick<ParticipantsContainerProps, "onActivityCollapsibleChanged">;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, WorkflowEditorProps> = (dispatch, { hostKey }) => ({
    onActivityCollapsibleChanged: (isExpanded) => dispatch(createUpdateActivityCollapsibleState(hostKey, "PARTICIPANTS", isExpanded)),
});

export const ParticipantsContainer = connect(mapStateToProps, mapDispatchToProps)(ParticipantsContainerComponent);
